const abDre022Products = {
	'tan-touch-bronzing-serum': {
		file: 'bs-ab-dre-022-tan-touch.png',
		alt: 'Sofort sonnengeküsst, kein Selbstbräuner, klinisch bestätigt',
	},
	'hydra-hero': {
		file: 'bs-ab-dre-022-hydra.png',
		alt: 'Sofort beruhigt, Feuchtigkeit die bleibt, zieht sofort ein',
	},
	// 'daily-depuff': {
	// 	file: 'bs-ab-dre-022-daily-depuff.png',
	// 	alt: 'Weniger Schwellungen, hellere Augenringe, feine Linien aufgepolstert',
	// },
};

const abDre022Product = () => {
	const path = location.pathname;
	const handles = Object.keys(abDre022Products);

	for (let i = 0; i < handles.length; i++) {
		const needle = '/products/' + handles[i];
		const index = path.indexOf(needle);
		if (index === -1) continue;

		const next = path.charAt(index + needle.length);
		if (next === '' || next === '/') return abDre022Products[handles[i]];
	}

	return null;
};

window.activateAbDre022 = () => {
	const product = abDre022Product();
	if (!product) return;

	const root = document.querySelector('product-info.main-product');
	if (!root) return;

	if (!window.activateAbDre022.watching) {
		const mainWrapper = root.querySelector('.main-product__mainGallery .swiper-wrapper');
		const thumbWrapper = root.querySelector('.main-product__thumbGallery .swiper-wrapper');

		if (mainWrapper && thumbWrapper) {
			window.activateAbDre022.watching = true;
			const rerun = () => window.activateAbDre022();
			const observer = new MutationObserver(rerun);
			observer.observe(mainWrapper, { childList: true });
			observer.observe(thumbWrapper, { childList: true });
			document.addEventListener('variant:change', rerun);
			document.addEventListener('product-variant-id-changed', rerun);
		}
	}

	const mainSwiper = root.querySelector('.main-product__mainGallery')?.swiper;
	const thumbSwiper = root.querySelector('.main-product__thumbGallery')?.swiper;
	if (!mainSwiper || !thumbSwiper) return;

	const script = document.querySelector('script[src*="bs-ab-dre-022.js"]');
	if (!script) return;

	const url = script.src.replace(/bs-ab-dre-022\.js(?:\?.*)?$/, product.file);
	const mainSlide = mainSwiper.slides[1];
	const thumbSlide = thumbSwiper.slides[1];
	if (!mainSlide || !thumbSlide) return;

	const mainImg = mainSlide.querySelector('img');
	const thumbImg = thumbSlide.querySelector('img');
	if (!mainImg || !thumbImg) return;

	const storeOriginal = (img) => {
		if (img.dataset.abDre022Stored === 'true') return;
		img.dataset.abDre022Stored = 'true';
		img.dataset.abDre022Src = img.getAttribute('src') || '';
		img.dataset.abDre022Srcset = img.getAttribute('srcset') || '';
		img.dataset.abDre022Sizes = img.getAttribute('sizes') || '';
		img.dataset.abDre022Alt = img.getAttribute('alt') || '';
	};

	const restoreImage = (slide, img) => {
		if (img.dataset.abDre022Stored !== 'true') return;
		const setOrRemove = (name, value) => {
			if (value) img.setAttribute(name, value);
			else img.removeAttribute(name);
		};
		setOrRemove('src', img.dataset.abDre022Src);
		setOrRemove('srcset', img.dataset.abDre022Srcset);
		setOrRemove('sizes', img.dataset.abDre022Sizes);
		setOrRemove('alt', img.dataset.abDre022Alt);
		slide.classList.remove('bs-ab-dre-022');
	};

	const variantInput = root.querySelector("form[data-type='add-to-cart-form'] .product-variant-id");
	const isPrimary = variantInput
		&& root.dataset.primaryVariantId
		&& String(variantInput.value) === String(root.dataset.primaryVariantId);

	if (!isPrimary) {
		restoreImage(mainSlide, mainImg);
		restoreImage(thumbSlide, thumbImg);
		return;
	}

	if ((mainImg.getAttribute('src') || '').indexOf(product.file) !== -1) return;

	const applyImage = (slide, img) => {
		storeOriginal(img);
		img.setAttribute('src', url);
		img.setAttribute('alt', product.alt);
		img.removeAttribute('srcset');
		img.removeAttribute('sizes');
		slide.classList.add('bs-ab-dre-022');
	};

	applyImage(mainSlide, mainImg);
	applyImage(thumbSlide, thumbImg);
};

document.addEventListener('DOMContentLoaded', () => {
	if (!abDre022Product()) return;

	let pendingAtc = false;

	document.addEventListener('submit', (event) => {
		const form = event.target;
		if (!form || !form.closest) return;

		const productForm = form.closest('product-form');
		const main = form.closest('.main-product');
		if (!productForm || !main || !main.contains(productForm)) return;

		const button = productForm.querySelector('[type="submit"]');
		if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

		pendingAtc = true;
	}, true);

	subscribe(PUB_SUB_EVENTS.cartUpdate, (data) => {
		if (!pendingAtc || !data || data.source !== 'product-form') return;
		pendingAtc = false;
		window['ablyft'] = window['ablyft'] || [];
		window['ablyft'].push({
			eventType: 'custom',
			eventName: 'add-to-cart-rate',
		});
	});

	subscribe(PUB_SUB_EVENTS.cartError, (data) => {
		if (!data || data.source !== 'product-form') return;
		pendingAtc = false;
	});
});

// document.addEventListener('DOMContentLoaded', () => {
// 	window.activateAbDre022();
// });
